let StatusOptions = [
    {
        value: 1,
        label: "启用"
    },
    {
        value: 0,
        label: "禁用"
    }
]

let AllowModifyFlagOptions = [
    {
        value: 1,
        label: "可编辑"
    },
    {
        value: 0,
        label: "不可编辑"
    }
]

let MenuType = [
    {
        value: 1,
        label: '菜单'
    }, {
        value: 2,
        label: "功能"
    }
]
let IntimacyOptions = [
    {
        value: 1,
        label: '专职'
    }, {
        value: 2,
        label: '兼职'
    }
]
export {
    StatusOptions,
    MenuType,
    AllowModifyFlagOptions,
    IntimacyOptions
}


// WEBPACK FOOTER //
// ./src/common/commonDTO.js